import create from 'zustand';

const [useDomStore, apiDomStore] = create(set => ({
	blockPageScroll: false,
	blockSideBarScroll: false,
	goTop: false,
	pageOpen: false,
	cantExitModal: false,
	activePreviewUrl: null,
	modalBodyLocked: false,
	searchBarOpen: false,
	setSearchBarOpen: bool => set({ searchBarOpen: bool }),
	setCantExitModal: bool => set({ cantExitModal: bool }),
	setPageOpen: bool => set({ pageOpen: bool }),
	setGoTop: bool => set({ goTop: bool }),
	setBlockPageScroll: bool => set({ blockPageScroll: bool }),
	setBlockSideBarScroll: bool => set({ blockSideBarScroll: bool }),
	setActivePreviewUrl: url => set({ activePreviewUrl: url }),
	setModalBodyLocked: bool => set({ modalBodyLocked: bool })
}));

export { apiDomStore };
export default useDomStore;
